<template>
  <Skeleton
    :paragraph="skeleton.paragraph"
    :active="skeleton.active"
  />
</template>
<script>


import Skeleton from '@/components/Skeleton/index';

export default {
  components: { Skeleton },
  data() {
    return {
      // 骨架屏
      skeleton: {},
    };
  },
  created(){
    this.setSkeleton();
  },
  methods: {
    // 设置骨划屏
    setSkeleton(){
      const skeleton = {
        // active: true,
        paragraph: {
          type: 'row',
          rows: [
            {
              type: 'col',
              cols: [],
            },
          ],
        },

      };
      const item = {
        type: 'row',
        colStyle: {
          marginRight: '20px',
          backgroundColor: '#fff',
        },
        // colContainStyle: {
        //   display: 'flex',
        //   alignItems: 'center',
        //   borderBottom: '1px solid #e6e7eb',
        //   padding: '10px 10px 20px',
        // },
        rows: [
          {
            type: 'rect',
            style: {
              width: '224px',
              height: '120px',
              // marginBottom: '10px',
            },
          },
          {
            type: 'row',
            rowStyle: {
              padding: '10px',
            },
            rows: [
              {
                type: 'rect',
                style: {
                  width: '100%',
                  height: '20px',
                  marginBottom: '10px',
                },
              },
              {
                type: 'rect',
                style: {
                  width: '100%',
                  height: '35px',
                  marginBottom: '10px',
                },
              },
              {
                type: 'rect',
                style: {
                  width: '60px',
                  height: '20px',
                  // marginBottom: '10px',
                },
              },
            ],
          },
        ],
      };
      for (let i=0;i<2;i++){
        const rowItem = {
          rowStyle: {
            marginBottom: '20px',
          },
          type: 'col',
          cols: [],
        };
        for (let j=0;j<4;j++){
          rowItem.cols.push(item);
        }
        skeleton.paragraph.rows.push(rowItem);
      }
      this.skeleton = skeleton;
    },
  },

};
</script>

